import React from "react"
import classnames from "classnames"

export interface ButtonProps {
  disabled?: boolean
  isLoading?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  size?: "lg" | "md" | "sm"
  text: string
  theme?: "primary" | "destroy"
  type?: "button" | "submit" | "reset"
  variant?: "filled" | "outline" | "naked"
}

export const Button = ({
  disabled = false,
  isLoading = false,
  onClick = undefined,
  size = "lg",
  text,
  theme = "primary",
  type = "button",
  variant = "filled",
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={classnames(
        "btn",
        `${size}-btn`,
        `${variant}-btn`,
        `${theme}-btn`,
        isLoading && "loading-btn",
      )}
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      <span className="spinner" />
      {text}
    </button>
  )
}
